<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table">
  <ng-container matColumnDef="region">
    <th mat-header-cell *matHeaderCellDef> Werelddelen </th>
    <td mat-cell *matCellDef="let data"> {{data.region ? data.region : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="allowedRegion">
    <th mat-header-cell *matHeaderCellDef> Ingesteld? </th>
    <td mat-cell *matCellDef="let data"> {{data.allowedRegion ? 'Ja' : 'Nee'}} </td>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <th mat-header-cell *matHeaderCellDef> Ingangsdatum </th>
    <td mat-cell *matCellDef="let data"> {{data.startDate ? data.startDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="endDate">
    <th mat-header-cell *matHeaderCellDef> Einddatum </th>
    <td mat-cell *matCellDef="let data"> {{data.endDate ? data.endDate : emptyValuePlaceholder}} </td>
  </ng-container>


  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
